/**
 * Created by Jie on 2020-11-05.
 * Modified by Shikha on 2021-04-19.
 */
import {TimelineLite} from "gsap";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {HorribleHeroesLayerConfig} from "../config/IHorribleHeroesLayerConfig";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {HorribleHeroesParsedGameData} from "../server/data/HorribleHeroesParsedGameData";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SoundManager} from "../resource/sound/SoundManager";

interface scatterEachReel {
    spinsAdded: number,
    scatterCollected: number
}

export class ScatterPlusOneAnimation extends BaseView {
    protected static additionalSpins: { [scattersCollected: number]: number } = {
        4: 1,
        5: 2
    };

    private readonly _layer: PIXI.Container;
    private _widOneAnimation: PIXI.spine.Spine[];
    private _scatterAnimation: PIXI.spine.Spine[];
    private _gameData: HorribleHeroesParsedGameData;
    //#344,#371,#316
    private updatedSpinCount: number = 0;

    constructor() {
        super();
        this._layer = StageManager.getLayer(HorribleHeroesLayerConfig.SYMBOL_WIN_ANIMATION.name);
    }

    public prepareData(data: HorribleHeroesParsedGameData): void {
        this.updatedSpinCount = data.freespinsLeft - data.addedNumberOfFreespinsThisSpin;
        /*reset to previous spin count*/
        this._gameData = data!;
    }

    //#431,#388,#384
    public updateSpinButton(reelId: number, symId: number, isScatter: boolean, isQuickStop: boolean, delay?: number): TimelineLite {
        const spinCountWild: number = 1,
            additionalSpin: number = !isScatter ? spinCountWild : this.getCurrentScatterSpins(reelId).spinsAdded,
            animationDuration: number = this._widOneAnimation[0].spineData.findAnimation("plusOne").duration;
        this.updateFreeSpins(additionalSpin);
        const timeline: TimelineLite = new TimelineLite(),
            startPosition: number[] = Helper.getSymbolPositions(reelId, symId);
        let animationType: PIXI.spine.Spine = this._widOneAnimation[0],
            animName: string = "plusOne";
        if (isScatter) {
            animationType = this._scatterAnimation[additionalSpin - 1];
            if (additionalSpin === 2) {
                animName = "plusTwo";
            }
        } else if (reelId > 0 && reelId < 4) {
            animationType = this._widOneAnimation[reelId - 1];
            timeline.add(this.playAnimation(animationType, "landingGlow"), 0);
        }
        animationType.position.set(startPosition[0], startPosition[1]);
        if (isQuickStop) {
            delay = 0;
            //#555
            //#532
            //#533,#529
        }
        timeline.add(this.setPlusAnimation(animationType, animationDuration, animName, isQuickStop), delay);
        //#486
        return timeline;
    }

    public updateFreeSpins(additionalSpins: number): void {
        this.updatedSpinCount = this.updatedSpinCount + additionalSpins;
    }

    /*get Additional Scatter spins for particular reel
     //#344,#371,#316
    * */
    public getCurrentScatterSpins(reelId: number): scatterEachReel {
        const sPos: number = this._gameData.scatterPositions![reelId],
            scatterCount: number = this._gameData!.scatterCountValue,
            scatterCollected: number = this._gameData!.getScattersCollected;
        let scatterReel: scatterEachReel = {spinsAdded: 0, scatterCollected: scatterCollected};// Default in FreeSpins
        if (sPos > -1) {
            switch (scatterCount) {
                case 2:
                    if (!this.checkScatterExisted(reelId, this._gameData.scatterPositions!)) {
                        scatterReel.spinsAdded = ScatterPlusOneAnimation.additionalSpins[4];
                        scatterReel.scatterCollected = 4;
                    } else {
                        scatterReel.spinsAdded = ScatterPlusOneAnimation.additionalSpins[scatterCollected];
                        scatterReel.scatterCollected = 5;
                    }
                    break;
                case 1:
                    scatterReel.spinsAdded = ScatterPlusOneAnimation.additionalSpins[scatterCollected];
                    scatterReel.scatterCollected = scatterCollected;
                    break;
            }
        }

        return scatterReel;
    }

    protected initAnimations(): void {
        //three wild can land at time
        this._widOneAnimation = ArrayHelper.initArrayWithValues(3, () => {
            const animation: PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("scatterPlusOne"));
            animation.visible = false;
            return animation;
        });
        //two scatter can land at a time
        this._scatterAnimation = ArrayHelper.initArrayWithValues(2, () => {
            const animation: PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("scatterPlusOne"));
            animation.visible = false;
            return animation;
        });
        //#344 371
    }

    private setPlusAnimation(animation: PIXI.spine.Spine, animationDuration: number, animName: string, isQuickStop: boolean): TimelineLite {
        const timeline: TimelineLite = new TimelineLite();
        if (isQuickStop) {
            //#486
            animationDuration = animationDuration / 4
        }
        timeline.add(() => {
            // #453
            SoundManager.playFSPlusSpin();
            this.playAnimation(animation, animName);
        }, 0);
        timeline.add(() => {
            SlotGame.keypad.setZeroBetSpinCounter(this.updatedSpinCount);
            this.clearAnimation(animation);
        }, animationDuration);
        return timeline;
    }

    private clearAnimation(animation: PIXI.spine.Spine): void {
        if (animation.parent === this._layer) {
            animation.visible = false;
            animation.state.clearTracks();
            this._layer.removeChild(animation);
        }
    }

    private playAnimation(animation: PIXI.spine.Spine, animName: string): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        this._layer.addChild(animation);
        animation.updateTransform();
        animation.visible = true;
        animation.state.setAnimation(0, animName, false);
        const duration: number = animation.spineData.findAnimation(animName).duration;
        tl.add(() => {

        }, duration);
        return tl;
    }

    /*check if scatter landed before current reel
     //#344,#371,#316
       * */
    private checkScatterExisted(currentReel: number, scatterPositions: number[]): boolean {
        let hasScatterOccured: boolean = false;
        for (let reelId: number = currentReel - 1; reelId > -1; reelId--) {
            const sPos: number = scatterPositions![reelId];
            if (sPos > -1) {
                hasScatterOccured = true;
            }
        }
        return hasScatterOccured;
    }
}